import Button from "components/global/Button";
import { socialIcons } from "constants/post";
import styled from "styled-components";
import CheckIcon from "icons/CheckIcon";
import { connect } from "react-redux";
import useManageChannels from "hooks/useManageChannels";
import PlusIcon from "icons/PlusIcon";
import { useMemo } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { SkeletonWrapper } from "./HomeStyle";

const Wrapper = styled.div`
  display: flex;
  padding: 24px;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
    0px 25px 35px 0px rgba(0, 0, 0, 0.03);
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }

  .channelList {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    @media (max-width: 1100px) {
      width: 100%;
      grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    }

    .channelCard {
      display: flex;
      padding: 8px;
      align-items: center;
      gap: 16px;
      border-radius: 12px;
      border: 1px solid #e2e2ea;
      background: #fff;
      justify-content: space-between;
      max-width: 196px;

      &.notConnected {
        background: #f8f8f8;
        border: 1px dashed #e2e2ea;
      }

      .plusBtnWrapper {
        border-radius: 50%;
        border: 1px dashed #e2e2ea;
      }

      @media (max-width: 1200px) {
        width: 100%;

        p {
          display: none;
        }
      }
    }
  }
`;

const allSocials = [
  "facebook",
  "instagram",
  "twitter",
  "linkedin",
  "youtube",
  "tiktok",
  "pinterest",
  "meta_threads",
];

const ConnectSocials = ({ brand, user }) => {
  const history = useHistory();
  const { platformList, loading, socials } = useManageChannels(brand?.id);

  const notConnectedPlatforms = useMemo(() => {
    return allSocials.filter((social) => !platformList.includes(social));
  }, [allSocials, platformList]);

  const handleCardClick = () => {
    history.push(`/dashboard/brands/${brand?.id}/edit/channels`);
  };

  return (
    <>
      {loading ? (
        <SkeletonWrapper>
          <div className="skeletonHeader">
            <div className="skeletonText" />
            <div className="skeletonButton" />
          </div>
          <div className="skeletonChannelList">
            {[...Array(6)].map((_, index) => (
              <div className="skeletonCard" key={index}>
                <div className="skeletonImage" />
                <div className="skeletonIcon" />
              </div>
            ))}
          </div>
        </SkeletonWrapper>
      ) : (
        <Wrapper>
          <div className="flexColumn alignStart gap24">
            <p className="l1-normal semiBold textLeft">
              Connect Social Media Channels
            </p>
            <Button
              text="Connect more channels"
              className="borderedGrey"
              fontSize="14px"
              height="36px"
              onClick={() => history.push("/dashboard/brands/create")}
            />
          </div>
          <div className="channelList">
            {socials.map((social) => (
              <div className="channelCard" key={social?.id}>
                <div className="flexRow alignCenter gap16">
                  <img
                    src={socialIcons.circle[social?.platform]}
                    alt="facebook"
                  />
                </div>
                <CheckIcon size={16} color="#149DFF" />
              </div>
            ))}
            {notConnectedPlatforms.map((platform) => (
              <div
                className="channelCard cursorPointer"
                key={platform}
                onClick={handleCardClick}
              >
                <div className="flexRow alignCenter gap16">
                  <img src={socialIcons.grey[platform]} alt={platform} />
                </div>
                <div className="plusBtnWrapper flexRow alignCenter justifyCenter">
                  <PlusIcon size={16} />
                </div>
              </div>
            ))}
          </div>
        </Wrapper>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    brand: state.brand,
    user: state.user,
  };
};

export default connect(mapStateToProps)(ConnectSocials);
